const CHUNK_SIZE = 0.4 * 1024 * 1024; // 419430.4 bytes
//Funcion para dividir la imagen en chunks
export const splitFileIntoChunksBase64 = async (
  file: File
): Promise<string[]> => {
  const chunks: string[] = [];
  let start = 0;

  while (start < file.size) {
    const end = Math.min(file.size, start + CHUNK_SIZE);
    const blobChunk = file.slice(start, end);
    const base64Chunk = await blobToBase64(blobChunk);
    chunks.push(base64Chunk);
    start = end;
  }

  return chunks;
};

// Transform chunkn in base 64
const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
